<template>
    <v-layout>
        <div class="w100 d-flex">
            <v-form ref="editParam" class="w100">
                <v-text-field class="w100" dense v-model="editedValue" :readonly="!editMode" :hide-details="!editMode" :rules="[required]"></v-text-field>
            </v-form>
            <div v-if="isAvailable" class="ml-3 d-flex" style="min-width: 60px">
                <v-tooltip v-if="!editMode" bottom open-delay="500">
                    <template #activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="ml-9" @click="editMode = true"> edit </v-icon>
                    </template>
                    <span>{{ $t('Изменить') }}</span>
                </v-tooltip>
                <div v-else>
                    <v-tooltip bottom open-delay="500">
                        <template #activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" @click="update"> mdi-checkbox-marked-circle </v-icon>
                        </template>
                        <span>{{ $t('Сохранить') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom open-delay="500">
                        <template #activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="ml-3" @click="cancelEdit"> mdi-close-circle </v-icon>
                        </template>
                        <span>{{ $t('Отменить') }}</span>
                    </v-tooltip>
                </div>
            </div>
        </div>
    </v-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormValidator from '@/mixins/FormValidator';
import BinCheckMixin from '@/mixins/BIN_Checker';
export default {
    props: ['value', 'fieldName', 'methodName', 'keyRID'],
    mixins: [BinCheckMixin, FormValidator],
    data: () => ({
        editMode: false,
        isAvailable: true,
        editedValue: null
    }),
    computed: {
        ...mapState('request', ['KSKFullInfo'])
    },
    methods: {
        ...mapActions('request', ['getKSKFullInfo', 'updateKSKInfo']),
        async update() {
            if (!this.$refs.editParam.validate()) return;

            let nvcKSKData = {};
            if (this.fieldName == 'bin') {
                nvcKSKData.bin = this.editedValue;
            }

            if (this.fieldName == 'chairman') {
                nvcKSKData.chairman = this.editedValue;
            }
            await this.updateKSKInfo({ iksk_rid: this.keyRID, nvcKSKData: nvcKSKData });
            await this.getKSKFullInfo({ KSKId: this.keyRID });
            this.editMode = false;
        },
        async cancelEdit() {
            this.editedValue = this.value;
            this.editMode = false;
        }
    },
    watch: {
        value() {
            this.editedValue = this.value;
        }
    }
};
</script>
